jQuery(document).ready(function($) {

    $( ".bloc_competences" ).each(function( index ) {

        var parent = $(this).find(".gauchedroite")
        var cibleArgs = parent.find(".gd")

        gsap.from( cibleArgs, {
            y : +300,
            duration: 1,
            stagger: .2,
            ease: "power2.out",
            scrollTrigger: {
                trigger: parent,
                markers: false,
                start: "top 80%",
                end: "top 30%",
                scrub: 1,
            }

        })

        var cibleParaPhoto = $(this).find(".visuel")

        gsap.from( cibleParaPhoto , {
            scale: 1.3,
            scrollTrigger: {
                trigger: cibleParaPhoto,
                start: 'top 100%',
                end: 'top 0%',
                scrub: 1,
                markers: false
            }
        })


    })

});